import React from 'react';
import './contactpage.css';

export class ContactPage extends React.Component {
    render(){
        return (
            <div class="contactpage">
                <div class="text-wrapper">
                    <h1>
                        <s>
                        前までソフトタイプのを使っていたんですが、<br />
                        金がかかるので眼鏡にしました。
                        </s>
                    </h1>
                    <h2><br />就職してお金に余裕ができたのでまたコンタクトにしましたw</h2>
                </div>
            </div>
        );
    }
}